'use client'

import type { FC } from 'react'

import { Button } from '@circlefin/components/lib/Button'
import { Icon } from '@circlefin/components/lib/Icon'
import { RateLimit } from '@features/faucet.constants'
import useTranslation from 'next-translate/useTranslation'

interface RequestLimitedProps {
  /**
   * Callback that will be invoked, when the user clicks the Go Back button.
   */
  onReset: () => void
}

export const RequestLimited: FC<RequestLimitedProps> = ({ onReset }) => {
  const { t } = useTranslation('faucet')
  return (
    <div
      className="flex max-w-lg flex-col space-y-4"
      data-testid="request-token-limited"
    >
      <Icon.Circle intent="warning" name="ExclamationSolid" />
      <h3 className="type-header-xl">{t`requestLimited.headline`}</h3>
      <p className="type-body-2xl">
        {t('requestLimited.description', {
          count: RateLimit.FAUCET_RATE_LIMIT_HOURS,
        })}
      </p>
      <Button className="w-58" onClick={onReset} size="lg" variant="primary">
        {t`requestLimited.goBack`}
      </Button>
    </div>
  )
}
